import { isNil, omitBy } from "lodash-es";
import { uuidv4 } from "../../../utils/uuid";
import { emailDesignSchema } from "../types/email-design-type";
import { emailHeaderSchema } from "../types/email-header-type";

import type { BrandKitLogo } from "../../brand-kit/server/brand-kit-service";
import type { EmailDesign as SupabaseEmailDesign } from "../server/supabase-email-design-service";
import type { EmailDesignSchema } from "../types/email-design-type";

export function makeDefaultTemplateValues(
  emailDesign?: SupabaseEmailDesign,
  branding_logo?: BrandKitLogo,
): EmailDesignSchema {
  const defaultData = {
    ...emailDesignSchema.getDefault(),
    header: emailHeaderSchema.getDefault(),
  };

  const newHeader = branding_logo
    ? {
        header: {
          ...defaultData.header,
          logo: {
            src: branding_logo.src,
            align: "left" as const,
            proportionOfMaxWidth: 1,
            version: 2,
          },
          text: null,
        },
      }
    : {};

  return {
    ...defaultData,
    ...newHeader,
    ...omitBy(emailDesign ?? {}, isNil),
    id: emailDesign?.id ?? uuidv4(),
  };
}
